import { ComponentChildren, h } from 'preact'
import classNames from 'classnames'
import Icon from '../assets'

interface Props {
    title: ComponentChildren,
    collapsible: boolean,
    newStyle?: boolean,
    isOpen?: boolean | null,
    togglePanel?: () => void,
    customClass?: string,
}

const PanelHeader = ({ title, collapsible = false, isOpen = null, newStyle = false, togglePanel, customClass = '' }: Props) => {
  const icon = isOpen ? (newStyle ? 'chevronUp' : 'arrowDropUp') : (newStyle ? 'chevronDown' : 'arrowDropdown')
  const iconSize = newStyle ? 24 : 18
  return (
    <div
      onClick={() => togglePanel && togglePanel()}
      class={classNames({
        'panel-heading': true,
        'panel-heading--collapsible': collapsible
      }, customClass
      )}
    >
      {title}
      {collapsible
        ? <Icon
          customClass='icon-toggle-panel'
          icon={icon}
          width={iconSize}
          height={iconSize}
        />
        : null}
    </div>
  )
}

export default PanelHeader
